var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('post-detail',{attrs:{"commonPost":_vm.post,"commonPosts":_vm.posts},on:{"postsUpdated":_vm.onPostsUpdated}}):(_vm.posts)?_c('post-list',{attrs:{"commonPosts":_vm.posts},on:{"postsUpdated":_vm.onPostsUpdated}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }